var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBook(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 118,
    height: 100,
    viewBox: "0 0 118 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M102.983 21.539C105.391 21.539 107.344 19.5861 107.344 17.1772C107.344 14.7683 105.391 12.8154 102.983 12.8154C100.574 12.8154 98.6211 14.7683 98.6211 17.1772C98.6211 19.5861 100.574 21.539 102.983 21.539Z",
    stroke: "#4C241D",
    strokeWidth: 3.15457,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.4771 75.9668C59.1924 75.9668 75.9855 59.1725 75.9855 38.4556C75.9855 17.7387 59.1924 0.944336 38.4771 0.944336C17.7618 0.944336 0.96875 17.7387 0.96875 38.4556C0.96875 59.1725 17.7618 75.9668 38.4771 75.9668Z",
    fill: "#E5EFEF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.7846 8.73828L27.375 15.1483",
    stroke: "#4C241D",
    strokeWidth: 3.15457,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.375 8.73828L33.7846 15.1483",
    stroke: "#4C241D",
    strokeWidth: 3.15457,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.604 23.2834C24.5675 23.2834 25.3485 22.5022 25.3485 21.5387C25.3485 20.5751 24.5675 19.7939 23.604 19.7939C22.6404 19.7939 21.8594 20.5751 21.8594 21.5387C21.8594 22.5022 22.6404 23.2834 23.604 23.2834Z",
    fill: "#4C241D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8594 38.9863H116.066V98.3064H21.8594V38.9863Z",
    fill: "#6B4F5B",
    stroke: "#4C241D",
    strokeWidth: 3.15457,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M68.9648 96.0117V38.637C68.9648 38.637 82.5027 24.866 107.323 29.4563V86.8311C107.323 86.8311 84.7585 84.535 68.9648 96.0117Z",
    fill: "white",
    stroke: "#4C241D",
    strokeWidth: 3.15457,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M77.6875 46.8077C83.6439 43.9931 90.1435 42.5145 96.7313 42.4756L77.6875 46.8077Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M77.6875 46.8077C83.6439 43.9931 90.1435 42.5145 96.7313 42.4756",
    stroke: "#B5A19C",
    strokeWidth: 3.15457,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M77.6875 53.7862C83.6439 50.9716 90.1435 49.493 96.7313 49.4541L77.6875 53.7862Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M77.6875 53.7862C83.6439 50.9716 90.1435 49.493 96.7313 49.4541",
    stroke: "#B5A19C",
    strokeWidth: 3.15457,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M77.6875 60.7657C83.6439 57.9511 90.1435 56.4725 96.7313 56.4336L77.6875 60.7657Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M77.6875 60.7657C83.6439 57.9511 90.1435 56.4725 96.7313 56.4336",
    stroke: "#B5A19C",
    strokeWidth: 3.15457,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M68.9627 96.0117V38.637C68.9627 38.637 55.4161 24.866 30.582 29.4563V86.8311C30.582 86.8311 53.1586 84.535 68.9627 96.0117Z",
    fill: "white",
    stroke: "#4C241D",
    strokeWidth: 3.15457,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M61.9837 19.7947L56.75 14.5605",
    stroke: "#FFCE56",
    strokeWidth: 3.15457,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M75.9414 19.7947L81.1751 14.5605",
    stroke: "#FFCE56",
    strokeWidth: 3.15457,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M68.9648 19.7943V12.8154",
    stroke: "#FFCE56",
    strokeWidth: 3.15457,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M60.0946 46.8077C54.1383 43.9925 47.6386 42.514 41.0508 42.4756L60.0946 46.8077Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M60.0946 46.8077C54.1383 43.9925 47.6386 42.514 41.0508 42.4756",
    stroke: "#B5A19C",
    strokeWidth: 3.15457,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M60.0946 53.7862C54.1383 50.971 47.6386 49.4925 41.0508 49.4541L60.0946 53.7862Z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M60.0946 53.7862C54.1383 50.971 47.6386 49.4925 41.0508 49.4541",
    stroke: "#B5A19C",
    strokeWidth: 3.15457,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M60.0946 60.7657C54.1383 57.9505 47.6386 56.472 41.0508 56.4336L60.0946 60.7657Z",
    fill: "white"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M60.0946 60.7657C54.1383 57.9505 47.6386 56.472 41.0508 56.4336",
    stroke: "#B5A19C",
    strokeWidth: 3.15457,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBook);
export default __webpack_public_path__ + "static/media/book.01eeca81de0c12743c5252442c2a19f5.svg";
export { ForwardRef as ReactComponent };